import React from "react";

/**
 * DardEDiscoLogo — Cyberpunk Stick-Figure Logo Component
 * 
 * Features:
 * - Iconic dance pose matching the hologram screen avatar:
 *   Continuous diagonal upper-arm line through the spine with angled forearms and joint nodes.
 * - Pure neon duotone styling: Magenta ring head & spine/legs (#ff2e88) + Electric Cyan arms (#00d3d9)
 * - Cybernetic HUD corner brackets [ ] reflecting real-time pose tracking
 * - High-contrast dark badge frame that pops on both light and dark backgrounds
 */
export default function Logo({ size = 32, className = "", style = {} }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      role="img"
      aria-label="Dard-e-Disco Logo"
      className={`logo-badge ${className}`}
      style={{
        display: "inline-block",
        verticalAlign: "middle",
        flexShrink: 0,
        borderRadius: size * 0.22,
        transition: "transform 200ms cubic-bezier(0.16, 1, 0.3, 1), filter 200ms ease",
        ...style,
      }}
    >
      {/* Dark badge background */}
      <rect width="64" height="64" rx="14" fill="#0a0a10" stroke="rgba(255, 255, 255, 0.12)" strokeWidth="1.2" />

      {/* Subtle HUD corner brackets in Cyan */}
      <path d="M 8 17 L 8 8 L 17 8" stroke="#00d3d9" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" opacity="0.75" />
      <path d="M 47 8 L 56 8 L 56 17" stroke="#00d3d9" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" opacity="0.75" />
      <path d="M 8 47 L 8 56 L 17 56" stroke="#00d3d9" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" opacity="0.75" />
      <path d="M 47 56 L 56 56 L 56 47" stroke="#00d3d9" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" opacity="0.75" />

      {/* Stick Figure: Open Magenta Ring Head */}
      <circle cx="32" cy="15" r="6" stroke="#ff2e88" strokeWidth="3" />

      {/* Spine */}
      <line x1="32" y1="21" x2="32" y2="40" stroke="#ff2e88" strokeWidth="3.2" strokeLinecap="round" />

      {/* Dancing Arms (Electric Cyan): Slanted diagonal shoulder crossing */}
      {/* Left arm: shoulder -> up-left elbow -> down-left hand */}
      <path
        d="M 32 28 L 19 21 L 14 33"
        stroke="#00d3d9"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="14" cy="33" r="2.4" fill="#00d3d9" />

      {/* Right arm: shoulder -> down-right elbow -> up-right hand */}
      <path
        d="M 32 28 L 45 35 L 50 23"
        stroke="#00d3d9"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="50" cy="23" r="2.4" fill="#00d3d9" />

      {/* Dancing Legs (Neon Magenta) */}
      <path
        d="M 32 40 L 23 49 L 19 58"
        stroke="#ff2e88"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M 32 40 L 41 49 L 45 58"
        stroke="#ff2e88"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
